//import logo from './logo.svg';
import './App.css';
import Rout from './Route/Rout';
//import { ToastContainer } from 'react-toastify';
function App() {
  return (
    <div className="App">
      <Rout/>
      {/* <ToastContainer
      autoClose={3000}
      position="top-right"
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      /> */}
    </div>
  );
}

export default App;
